/**
 * Event triggered when the language changes.
 * @type {string} - The event name.
 */
export const UPDATE_LANGUAGE_EVENT = 'update-language';

/**
 * Event triggered when the user uploads an image.
 * @type {string} - The event name.
 */
export const UPLOAD_IMG_RESULT_EVENT = 'upload-img-result';

/**
 * Event triggered when the user update the search query object.
 * @type {string} - The event name.
 */
export const SEARCH_IMG_OBJECT_EVENT = 'search-img-object';

/**
 * Event triggered when the api returns the query.
 * @type {string} - The event name.
 */
export const SEARCH_IMG_RESULT_EVENT = 'search-img-result';

/**
 * Event triggered when the api returns the reports query for the search img result.
 * @type {string} - The event name
 */
export const SEARCH_IMG_REPORTS_RESULT_EVENT = 'search-img-reports-result';

/**
 * Event triggered when the api returns the reports query.
 * @type {string} - The event name.
 */
export const SEARCH_REPORTS_RESULT_EVENT = 'search-reports-result';

/**
 * Event triggered when the api returns the reports details query.
 * @type {string} - The event name.
 */
export const SEARCH_REPORT_DETAILS_RESULT_EVENT = 'search-report-details-result';

/**
 * Event triggered when the user clicks on the delete button and remove one or more images in the searcher.
 * @type {string} - The event name.
 */
export const REMOVE_SEARCH_IMG_OBJECT_EVENT = 'remove-search-img-object';

/**
 * Event triggered when the user need to run the search query only.
 * @type {string} - The event name.
 */
export const TRIGGER_SEARCH_QUERY_EVENT = 'trigger-search-query';

/**
 * Event triggered when the user need to run the search query only.
 * @type {string} - The event name.
 */
export const UPDATE_FIELD_TYPE_FILTER_EVENT = 'update-field-type-filter';

/**
 * Event triggered when the user update the Type file filter.
 * @type {string} - The event name.
 */
export const SYNCH_TYPE_FILTER_SEARCH_OPTIONS_EVENT = 'synch-type-filter-search-options';

/**
 * Event triggered to update the AI searcher.
 * @type {string} - The event name.
 */
export const UPDATE_AI_SEARCHER_EVENT = 'update-ai-searcher';

/**
 * Event triggered to update the AI searcher.
 * @type {string} - The event name.
 */
export const UPDATE_ORDER_BY_EVENT = 'update-order-by';

/**
 * Event triggered to reset the filters.
 * @type {string} - The event name.
 */
export const TRIGGER_RESET_FILTERS_EVENT = 'trigger-reset-filters';

/**
 * Event triggered to update the user info header.
 * @type {string} - The event name.
 */
export const TRIGGER_UPDATE_USER_INFO_HEADER_EVENT = 'trigger-update-user-info-header';

/**
 * Event triggered to trigger the carte response.
 * @type {string} - The event name.
 */
export const TRIGGER_RESPONSE_CART_EVENT = 'trigger-response-cart';

/**
 * Event triggered to trigger the download lightbox.
 * @type {string} - The event name.
 */
export const TRIGGER_RESPONSE_DOWNLOAD_EVENT = 'trigger-response-download-lightbox';

/**
 * Event triggered to trigger the end download cart elements.
 * @type {string} - The event name.
 */
export const TRIGGER_END_DOWNLOAD_CART_ELEMENTS_EVENT =
    'trigger-end-download-cart-elements';

/**
 * Event triggered to update the zoom of an active in the list views
 * @type {string} - The event name.
 */
export const TRIGGER_UPDATE_ZOOM_ACTIVES_EVENT = 'trigger-update-zoom-actives';

/**
 * Event triggered to update the dark mode.
 * @type {string} - The event name.
 */
export const TRIGGER_UPDATE_DARK_MODE_EVENT = 'trigger-update-dark-mode';

/**
 * Event triggered to show the loading component.
 * @type {string} - The event name.
 */
export const TRIGGER_UPDATE_PER_PAGE_EVENT = 'trigger-update-per-page';

/**
 * Event triggered to hide the loading component.
 * @type {string} - The event name.
 */
export const TRIGGER_HIDE_LOADING_COMPONENT_EVENT = 'trigger-hide-loading-component';

/**
 * Event triggered to show the loading component.
 * @type {string} - The event name.
 */
export const TRIGGER_SHOW_LOADING_COMPONENT_EVENT = 'trigger-show-loading-component';

/**
 * Event triggered to show the download options on a card.
 * @type {string} - The event name.
 */
export const TRIGGER_SHOW_DOWNLOAD_OPTIONS_CARD_EVENT =
    'trigger-show-download-options-card';

/**
 * Event triggered to show the download options on a zoom modal.
 * @type {string} - The event name.
 */
export const TRIGGER_SHOW_DOWNLOAD_OPTIONS_ZOOM_MODAL_EVENT =
    'trigger-show-download-options-zoom-modal';

/**
 * Event triggered to update the selected tab.
 * @type {string} - The event name.
 */
export const TRIGGER_CHANGE_DESCRIPTION_ACTIVES_EVENT =
    'trigger-change-description-actives';

/**
 * Event triggered to handle the overlay click.
 * @type {string} - The event name.
 */
export const TRIGGER_OVERLAY_CLICK_EVENT = 'trigger-overlay-click';

/**
 * Event to toggle the disabled state of the all option
 * @type {string}
 */
export const TOGGLE_ALL_OPTION_DISABLED_EVENT = 'toggle-all-option-disabled-event';

/**
 * Event to toggle the disabled AI input
 * @type {string}
 */
export const TOGGLE_DISABLED_AI_INPUT_EVENT = 'toggle-disabled-ai-input-event';

/**
 * Event to toggle the custom filter chip close icon
 * @type {string}
 */
export const TOGGLE_CUSTOM_FILTER_CHIP_CLOSE_ICON_EVENT =
    'toggle-custom-filter-chip-close-icon-event';
